var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.685,
    height: 29.687,
    viewBox: "0 0 29.685 29.687",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Screen Shot 2020-11-15 at 2.15.52 PM",
    transform: "translate(-147 -44.937)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    "data-name": "Path 612",
    d: "M187.818,296.61h-9.766A4.955,4.955,0,0,1,173,291.56V280.9a4.741,4.741,0,0,1,1.589-3.65q4.966-4.523,9.951-9.029a4.872,4.872,0,0,1,6.631.032q4.982,4.5,9.947,9.033a4.566,4.566,0,0,1,1.539,3.468c.021,3.618.052,7.237,0,10.859a4.95,4.95,0,0,1-5.032,5.007C194.349,296.583,191.084,296.61,187.818,296.61Zm-.078-2.85H197.5a1.947,1.947,0,0,0,2.041-1.907q.017-5.444,0-10.889a2.21,2.21,0,0,0-.752-1.641q-4.79-4.37-9.6-8.722a2.009,2.009,0,0,0-2.88.017l-9.8,8.9a1.955,1.955,0,0,0-.461.81,2.585,2.585,0,0,0-.074.818q0,5.213,0,10.425a1.991,1.991,0,0,0,2.2,2.186Z",
    transform: "translate(-26 -222)",
    fill: "current"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.329af604.svg";
export { ForwardRef as ReactComponent };